import { appRoute } from "@/components/routes/app-route";
import { AppItineraryOrNode } from "@/types/otp/+extended";

export function useIsSelectedPlan(plan: AppItineraryOrNode) {
    const data = appRoute.useSearch({ select: (search) => search.data })
    return !!plan && data?.selected === getPlanKey(plan)
}

export function getPlanKey({ legs, generalizedCost, startTime, endTime }: AppItineraryOrNode) {
    if (!legs || legs.length <= 0 || !startTime || !endTime) {
        return '';
    }

    const match = legs.find(l => l.route?.longName)

    return `${match?.route?.longName}-${match?.trip?.gtfsId}-${startTime}-${endTime}-${generalizedCost}`
}